import request from '@/utils/request'

// 查询奖励
export function getRewardList(params) {
  return request({
    url: '/user/admin/enterprise/job/query/rewardRule',
    method: 'GET',
    params,
  })
}

// 查询岗位关联奖励
export function getJobRelationRewardList(params) {
  return request({
    url: '/user/admin/enterprise/job/queryByEnterpriseCode/rewardRule',
    method: 'GET',
    params,
  })
}

// 新增奖励
export function addReward(data) {
  return request({
    url: '/user/admin/enterprise/job/add/rewardRule',
    method: 'POST',
    data,
  })
}

// 修改奖励
export function updateReward(data) {
  return request({
    url: '/user/admin/enterprise/job/update/rewardRule',
    method: 'POST',
    data,
  })
}

// 删除奖励
export function delReward(id) {
  return request({
    url: `/user/admin/enterprise/job/del/rewardRule/${id}`,
    method: 'POST',
  })
}

// 修改奖励状态
export function updateRewardStatus(data) {
  return request({
    url: '/user/admin/enterprise/job/updateRewardStatus',
    method: 'POST',
    data,
  })
}

// 查询奖励-待支付信息
export function getRewardPay(params) {
  return request({
    url: '/user/admin/enterprise/job/queryRewardPay',
    method: 'GET',
    params,
  })
}
